export const enum HIGHLIGHTED_FEATURES {
  ADAPTIVE_CRUISE_CONTROL = 'Adaptive Cruise Control',
  ALLOY_WHEELS = 'Alloy Wheels',
  ANDROID_AUTO = 'Android Auto',
  APPLE_CARPLAY = 'Apple CarPlay',
  WIRELESS_ANDROID_AUTO = 'Wireless Android Auto',
  WIRELESS_APPLE_CARPLAY = 'Wireless Apple CarPlay',
  APPLE_CARPLAY_ANDROID_AUTO_LEGACY = 'Apple CarPlay / Android Auto',
  APPLE_CARPLAY_ANDROID_AUTO = 'Apple CarPlay & Android Auto',
  WIRELESS_APPLE_CARPLAY_ANDROID_AUTO = 'Wireless Apple CarPlay & Android Auto',
  WIRELESS_APPLE_CARPLAY_WIRELESS_ANDROID_AUTO = 'Wireless Apple CarPlay & Wireless Android Auto',
  APPLE_CARPLAY_WIRELESS_ANDROID_AUTO = 'Apple CarPlay & Wireless Android Auto',
  GPS_NAVIGATION = 'GPS Navigation',
  HEADS_UP_DISPLAY = 'Heads Up Display',
  LEATHER_SEATS = 'Leather Seats',
  REAR_PARKING_CAMERA = 'Rear Parking Camera',
  REAR_PARKING_SENSOR = 'Rear Parking Sensors',
  SUN_ROOF = 'Sunroof',
  HEATED_SEATS = 'Heated Seats',
  VENTILATED_SEATS = 'Ventilated Seats',
  HEATED_VENTILATED_SEATS_LEGACY = 'Heated / Ventilated Seats',
  HEATED_VENTILATED_SEATS = 'Heated & Ventilated Seats',
  PUSH_START = 'Push Start',
  KEYLESS_ENTRY = 'Keyless Entry',
  PUSH_START_KEYLESS_ENTRY_LEGACY = 'Push Start / Keyless Entry',
  PUSH_START_KEYLESS_ENTRY = 'Push Start & Keyless Entry',
  ROOF_RAILS = 'Roof Rails',
  ROOF_RACKS = 'Roof Racks',
  ROOF_RACKS_RAILS_LEGACY = 'Roof Racks / Rails',
  ROOF_RACKS_RAILS = 'Roof Racks & Roof Rails',
  TOW_PACK = 'Tow Pack',
  TOW_PACK_BALL = 'Tow Pack / Tow Ball',
}
